/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { usePermissions } from "../../redux/permissions";

const PermissionBasedRedirect = () => {
  const navigate = useNavigate();
  const [hasNavigated, setHasNavigated] = useState(false);
  const [retryCount, setRetryCount] = useState(0);
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const role = userDetails?.roles && userDetails.roles.length > 0;

  const membersOutreachPermissions = usePermissions("Member Outreach");
  const dashboardPermissions = usePermissions("Dashboard");
  const providerOutreachPermissions = usePermissions("Provider Outreach");
  const pharmacyOutreachPermissions = usePermissions("Pharmacy Outreach");
  const manualTasksPermissions = usePermissions("Manual Tasks");
  const roleManagementPermissions = usePermissions("Role Management");
  const cagConfigPermissions = usePermissions("CG+ Assessment Templates");

  const checkAndNavigate = () => {
    if (!role) {
      navigate("/no-role", { replace: true });
      return true;
    }

    const hasAnyTruePermission = [
      membersOutreachPermissions.canRead,
      dashboardPermissions.canRead,
      providerOutreachPermissions.canRead,
      pharmacyOutreachPermissions.canRead,
      manualTasksPermissions.canRead,
      roleManagementPermissions.canRead,
      cagConfigPermissions.canRead,
    ].includes(true);

    if (!hasAnyTruePermission && retryCount < 10) {
      setRetryCount((prev) => prev + 1);
      return false;
    }

    if (membersOutreachPermissions.canRead === true) {
      navigate("/members/member-outreach", { replace: true });
      return true;
    }

    const navigationOrder = [
      {
        permission: dashboardPermissions,
        path: "/dashboard",
        name: "Dashboard",
      },
      {
        permission: providerOutreachPermissions,
        path: "/provider-outreach",
        name: "Provider Outreach",
      },
      {
        permission: pharmacyOutreachPermissions,
        path: "/pharmacy-outreach",
        name: "Pharmacy Outreach",
      },
      {
        permission: manualTasksPermissions,
        path: "/manual-tasks",
        name: "Manual Tasks",
      },
      {
        permission: roleManagementPermissions,
        path: "/role-management",
        name: "Role Management",
      },
      {
        permission: cagConfigPermissions,
        path: "/cg-config",
        name: "CG+ Assessment Templates"
      }
    ];

    for (const item of navigationOrder) {
      if (item.permission.canRead === true) {
        navigate(item.path, { replace: true });
        return true;
      }
    }

    if (retryCount >= 10) {
      const token = localStorage.getItem("token");
      if (token) {
        navigate("/dashboard", { replace: true });
        return true;
      } else {
        navigate("/landing", { replace: true });
        return true;
      }
    }

    return false;
  };

  useEffect(() => {
    if (hasNavigated) return;

    const timer = setTimeout(() => {
      const navigated = checkAndNavigate();
      if (navigated) {
        setHasNavigated(true);
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [
    hasNavigated,
    retryCount,
    navigate,
    membersOutreachPermissions.canRead,

    dashboardPermissions.canRead,
    providerOutreachPermissions.canRead,
    pharmacyOutreachPermissions.canRead,
    manualTasksPermissions.canRead,
    roleManagementPermissions.canRead,
    cagConfigPermissions.canRead,
  ]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        fontSize: "16px",
        color: "#666",
      }}
    >
      Loading...
    </div>
  );
};

export default PermissionBasedRedirect;
